export default "__VITE_ASSET__D$bO7Aaa__"